

import { Auth0ContextInterface } from '@equipmentshare/auth0-react'
import { type Auth } from '../../types'
import { goToPage } from '../../utils/navigation'
import { getAuth0ApplicationConfiguration } from '../../ts/Auth/Config'
import { Login } from '../../ts/Login'

type Auth0ApplicationConfiguration = {
	readonly audience: string,
	readonly clientId: string,
	readonly domain: string,
	readonly redirectUri: string,
}

export const parseJWT = ( token: string ): Auth => {
	try {
		const parsedToken = JSON.parse( atob( token.split( '.' )[ 1 ] ) )
		const { aud: audience } = parsedToken

		return {
			jwt: token,
			companyId: parsedToken[ `${audience[ 0 ]}/es_company_id` ],
			userId: parsedToken[ `${audience[ 0 ]}/es_user_id` ],
			securityLevelId: parsedToken[ `${audience[ 0 ]}/es_security_level_id` ],
		}
	} catch ( error: unknown ) {
		throw new Error( String( error ) )
	}
}

export const attemptToGetAuthToken = async( auth0: Auth0ContextInterface ): Promise<Auth> => new Promise( ( resolve, reject ) => {
	const { audience }: Auth0ApplicationConfiguration = getAuth0ApplicationConfiguration()

	auth0.getAccessTokenSilently( {
		audience,
	} ).then( ( jwt: string ) => {
		resolve( parseJWT( jwt ) )
	} ).catch( ( { error }: { readonly error: Error } ) => {
		reject( new Error( String(error) ) )
	} )
} )


export const getAuthOrRedirect = async( auth0: Auth0ContextInterface ): Promise<Auth> => new Promise( ( resolve, reject ) => {
	attemptToGetAuthToken(auth0).then( ( credentials: Auth ) => {
		resolve( credentials )
	} ).catch( () => {
		goToPage( Login.href() )

		reject( new Error( 'Not logged in' ) )
	} )
} )
